import React from "react";

function MiniHero({ title, className, homeRef, onScroll }) {
  return (
    <header
      ref={homeRef}
      onScroll={onScroll}
      className="position-relative w-100 pt-80"
      style={{ minHeight: "380px" }}
    >
      <div className="position-absolute start-0 top-0 w-100 full-height main-hero linear-gradient-primary-bg z-index-1"></div>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center mt-5">
          <h1 className={className}>{title}</h1>
        </div>
      </div>
    </header>
  );
}

export default MiniHero;
